import React from 'react';
import styled from 'styled-components';

const MainFace = styled.img`
  border: 5px solid #ffffff;
  border-radius: 50%;
  width: 56%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  position: relative;
`;

const MainCover = styled.img`
  width: 100%;
  display: block;
  position: absolute;
`;

const TopPad = styled.div`
  padding-top: 20%;
`;

const SidePad = styled.div`
  padding-left: 10%;
  padding-right: 10%;
`;

class ProfileCard extends React.Component {
  render() {
    return (
      <div>
        <MainCover src={this.props.cover}></MainCover>
        <TopPad>
          <MainFace src={this.props.profile}></MainFace>
        </TopPad>
        <SidePad>
          <h1>{this.props.name}</h1>
          <p>{this.props.about}</p>
        </SidePad>
        <div className="footer">
          <a target='_blank' href='https://www.instagram.com/talon_jin/'><i class="fab fa-instagram"></i></a>
          <a target='_blank' href={require('../files/Resume_TalonJin-Fullstack.pdf')}><i className="fas fa-file"></i></a>
          <a target='_blank' href='https://github.com/talonjin'><i className="fab fa-github"></i></a>
          <a target='_blank' href='https://www.linkedin.com/in/talonjin'><i className="fab fa-linkedin"></i></a>
          <a target='_top' href='mailto:t35jin@uwaterloo.ca?Subject=Hello%20Talon'><i className="fas fa-envelope"></i></a>
        </div>
      </div>
    );
  }
}

export default ProfileCard;



// WEBPACK FOOTER //
// ./src/components/ProfileCard.js